// pages/order/orderHistory/orderHistoryDetail/subviews/orderDetailSection/OrderDetailsItemCell.tsx
import React from 'react';
import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import type { HistoryOrderTicketItemEntity, OrderStatus } from 'types/dto/order';
import './OrderDetailsItemCell.scss';
import OrderStatusTag from 'components/orderStatusTag/OrderStatusTag';

interface DetailItemProps {
  label: string;
  value: string;
  className?: string;
}

const DetailItem: React.FC<DetailItemProps> = ({
  label,
  value,
  className = '',
}) => {
  return (
    <div className={`detail-item ${className}`}>
      <span className="detail-label">{label}</span>
      <span className="detail-value">{value}</span>
    </div>
  );
};

interface OrderDetailsItemCellProps {
  item: HistoryOrderTicketItemEntity;
  itemNumber: number; //index of item in all tickets
  ticketNumber?: string;
}

const OrderDetailsItemCell: React.FC<OrderDetailsItemCellProps> = ({
  item,
  itemNumber,
  ticketNumber,
}) => {
  const { t } = useTranslation('order_history');

  const formatPrice = (price: number) => {
    return `$${(price || 0).toFixed(2)}`;
  };

  return (
    <div className="order-details-item-cell-container">
      {/* Item Header */}
      <div className="item-header">
        <div className="item-title-section">
          <span className="item-number">{itemNumber}. </span>
          <span className="item-name">{item.name || '-'}</span>
          <OrderStatusTag status={item.status as OrderStatus} statusName={item.status} />
        </div>
      </div>

      {/* Item Details Grid */}
      <Row className="item-details-grid" gutter={16}>
        <Col xs={24} md={14} className="item-details-col">
          <DetailItem label={t('ticketNumber')} value={ticketNumber || ''} />
          <DetailItem label={t('type')} value={item.washMethod || ''} />
          <DetailItem label={t('brand')} value={item.brand || ''} />
          <DetailItem label={t('mainColor')} value={item.color || ''} />
        </Col>

        <Col xs={24} md={10} className="item-details-col">
          <DetailItem label={t('tagNumber')} value={item.tag || ''} />
          <DetailItem label={t('packing')} value={item.packing || ''} />
          <DetailItem label={t('service')} value={item.service || ''} />
          <DetailItem
            label={t('itemPrice')}
            value={formatPrice(item.origAmount || 0)}
            className="price"
          />
        </Col>
      </Row>

      {(item.surcharges || []).map((surcharge, index) => (
        <Row key={index} gutter={16}>
          <Col xs={24} md={14} className="item-details-col">
            <DetailItem label={t('surcharge')} value={surcharge.name || ''} />
          </Col>
          <Col xs={24} md={10} className="item-details-col">
            <DetailItem
              label={t('surchargePrice')}
              value={formatPrice(surcharge.amount || 0)}
              className="price"
            />
          </Col>
        </Row>
      ))}
    </div>
  );
};

export default OrderDetailsItemCell;